import {getRouteSearchParams} from 'envs/_current/history'

// Link "tương đối" giữ NGUYÊN path hiện tại (Workspace thật /workspace/:idname/course HAY portal
// /access-portal?org_id=&feature_key=), chỉ đổi/thêm các query param truyền vào - THAY cho hardcode
// "/workspace/course?rel=..." trước đây trong CourseDashboard.js/renderCourseEnrollment.js (đưa
// user RA KHỎI access-portal khi bấm từ đó, mất org_id/feature_key vì path tuyệt đối trỏ thẳng
// sang /workspace/course). Dùng qua <Link to={buildCourseRelLink({rel: 'course', ...})}>.
export const buildCourseRelLink = (params) => {
    const sp = getRouteSearchParams()
    Object.entries(params).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') sp.delete(key)
        else sp.set(key, value)
    })
    return {search: '?' + sp.toString()}
}
